import { ExportItemSetFormat } from '@exam-management/graphql';

export enum ItemSetExportFileTemplate {
  QUESTION_WITH_CHOICES = 'QUESTION_WITH_CHOICES',
  QUESTION_WITH_CHOICES_AND_SOLUTION = 'QUESTION_WITH_CHOICES_AND_SOLUTION',
}

export const ITEM_SET_EXPORT_FILE_TYPE_OPTIONS = [
  {
    label: 'PDF (.pdf)',
    value: ExportItemSetFormat.Pdf,
  },
  {
    label: 'Microsoft Word (.docx)',
    value: ExportItemSetFormat.Docx,
  },
];

export const ITEM_SET_EXPORT_FILE_TEMPLATE_OPTIONS = [
  {
    label: 'โจทย์, ตัวเลือก',
    value: ItemSetExportFileTemplate.QUESTION_WITH_CHOICES,
  },
  {
    label: 'โจทย์, ตัวเลือก, และเฉลย',
    value: ItemSetExportFileTemplate.QUESTION_WITH_CHOICES_AND_SOLUTION,
  },
];

export { ExportItemSetFormat };
